export const en = {
  footer: {
    cta: "Start making an impact in your community today",
    copyright: "© Purposely",
    tagline: "The AI co-pilot for corporate volunteering. Purpose, automated.",
    location: "Made in Vancouver, BC",
    sections: {
      company: {
        title: "Company",
        links: {
          about: "About Us",
          contact: "Contact",
          privacy: "Privacy Policy",
          terms: "Terms of Use"
        }
      },
      product: {
        title: "Product",
        links: {
          features: "Features",
          howItWorks: "How it works",
          integrations: "Integrations",
          reporting: "Reporting",
          eventManagement: "Event Management",
          referral: "Referral Program",
        }
      },
      resources: {
        title: "Resources",
        links: {
          caseStudies: "Case Studies",
          nonprofits: "For Nonprofits",
          whatsNew: "What's New",
          blog: "Blog",
          helpCenter: "Help Center",
        }
      },
      legal: {
        title: "Legal",
        links: {
          security: "Security",
          cookiePreferences: "Cookie preferences",
        }
      },
      affiliations: {
        title: "Affiliations"
      },
      connect: {
        title: "Connect",
        socialAlt: {
          facebook: "Facebook link",
          twitter: "Twitter link",
          instagram: "Instagram link",
          linkedin: "LinkedIn link"
        }
      }
    },
    purpleHeartAlt: "Purposely's purple heart"
  }
}